import React, { useEffect, useState } from 'react';
import { Form, Input, Select, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { creatADdomainConfig, resetProgress, setCurrent, setStatus } from 'redux/slices/setupSlice';
import {
  ContentWrap,
  FormColWrap,
  FormRowWrap,
  FormWrap,
  StyledButton,
  StyledFormItem,
  SubHeader,
  SubHeaderChild,
  SubHeaderWrap,
} from './style';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { FigCaption } from 'pages/license/style';
import { InputPatternRule, InputPatternRuleDomainAdminDn } from 'utils/input_pattern';

const AdDomainConfig = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { loading } = useSelector((state) => state.setupSlice);
  const [passwordMatch, setPasswordMatch] = useState(false);

  useEffect(() => {
    dispatch(setStatus('process'));
    dispatch(resetProgress());
  }, []);

  const onFinish = async (value) => {
    value.domainName = value.domainName.trim();
    value.fqdn = value.fqdn.trim();
    value.username = value.username.trim();
    const values = {
      ...value,
      OUAdmin: '',
      SuperAdmin: '',
      PortalAdmin: '',
      port: parseInt(value.port),
      passwordThreshold: parseInt(value.passwordThreshold),
    };
    try {
      const sweetAlert = await dispatch(creatADdomainConfig(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        if (
          sweetAlert.payload.data === 'Domain name is already in use.' ||
          sweetAlert.payload.data === 'The Connection Fails. Please check your details and retry.' ||
          sweetAlert.payload.data === 'FQDN is already in use.' ||
          sweetAlert.payload.data === 'IPAddress is already in use.'
        ) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'info', buttonColor: 'blue' });
        } else {
          dispatch(setStatus('finish'));
          await message.success(sweetAlert.payload.data.message);
          dispatch(setCurrent(1));
        }
      } else if (sweetAlert.payload && sweetAlert.payload.status === 400) {
        dispatch(setStatus('error'));
        if (sweetAlert.payload.data) {
          await message.error(sweetAlert.payload.data);
        }
      } else {
        dispatch(setStatus('error'));
        await message.warning('There is problem to connection time');
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
  };
  const handleSecurityTypeChange = (value) => {
    const newPort = value === 'SSL' ? 636 : 389;
    form.setFieldsValue({ port: newPort });
  };

  return (
    <ContentWrap>
      <SubHeaderWrap>
        <SubHeader>Configure Primary AD Domain:</SubHeader>
        <SubHeaderChild>You can change it later</SubHeaderChild>
      </SubHeaderWrap>
      <FormWrap>
        <Form
          form={form}
          name='Configure Primary AD Domain'
          layout='vertical'
          onFinish={onFinish}
          initialValues={{ securityType: 'SSL', port: 636, passwordThreshold: 42 }}
        >
          <FormRowWrap>
            <FormColWrap>
              <Form.Item
                label='Domain Name:'
                name='domainName'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Domain Name!',
                  },
                  {
                    pattern: InputPatternRule.pattern,
                    message: InputPatternRule.message,
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label='FQDN:'
                name='fqdn'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your FQDN!',
                  },
                  {
                    pattern: InputPatternRule.pattern,
                    message: InputPatternRule.message,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </FormColWrap>
            <FormColWrap>
              <Form.Item
                label='Server Name/IP:'
                name='ipAddress'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Server Name!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label='Admin User (DN):'
                name='username'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Admin User(DN)!',
                  },
                  {
                    pattern: InputPatternRuleDomainAdminDn.pattern,
                    message: InputPatternRuleDomainAdminDn.message,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </FormColWrap>
            <FormColWrap>
              <Form.Item
                label='Password:'
                name='password'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Password!',
                  },
                ]}
              >
                <Input.Password visibilityToggle={false} />
              </Form.Item>
              <Form.Item
                label='Confirm Password:'
                name='confirmPassword'
                dependencies={['password']}
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your Password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        setPasswordMatch(true);
                        return Promise.resolve();
                      } else {
                        setPasswordMatch(false);
                        return Promise.reject('passwords do not match!');
                      }
                    },
                  }),
                ]}
              >
                <Input.Password visibilityToggle={false} />
              </Form.Item>
            </FormColWrap>
            <FormColWrap>
              <Form.Item
                label='Security Type:'
                name='securityType'
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select
                  allowClear
                  showSearch
                  placeholder='Select'
                  defaultValue='SSL'
                  onChange={handleSecurityTypeChange}
                >
                  <Select.Option value='Plain'>Plain</Select.Option>
                  <Select.Option value='SSL'>SSL</Select.Option>
                  <Select.Option value='TLS'>TLS</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label='Port:'
                name='port'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your Port!',
                  },
                ]}
              >
                <Input type='number' />
              </Form.Item>
            </FormColWrap>
            <FormColWrap className='singleBox'>
              <div style={{ width: '100%', marginBottom: 24 }}>
                <Form.Item
                  label='Maximum Password Age:'
                  name='passwordThreshold'
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the Threshold!',
                    },
                  ]}
                  style={{ marginBottom: 0 }}
                >
                  <Input type='number' />
                </Form.Item>
                <FigCaption>**Configure as per your AD group policy</FigCaption>
              </div>
            </FormColWrap>
          </FormRowWrap>
          <StyledFormItem>
            <StyledButton type='primary' htmlType='submit' disabled={!passwordMatch || loading}>
              {loading ? 'Connecting...' : 'Connect'}
            </StyledButton>
          </StyledFormItem>
        </Form>
      </FormWrap>
    </ContentWrap>
  );
};

export default AdDomainConfig;
